import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTokens,
  setUser,
  setSubscription,
  setOnboarding,
  setBidderOnboarding,
  setBidderUser,
} from "store";
import {
  googleLogin,
  getUser,
  getSubscriptionByUserUuid,
  checkAndUpdateBidder,
  getBidderOnboardingOfUser,
} from "services";
import { useRouter } from "next/router";
import { Loader } from "app";
import { createBidderOnboardingWithOutData } from "services/bidder";

export default function AuthSuccess() {
  const dispatch = useDispatch();
  const router = useRouter();
  const redirectUrl = useSelector((state: any) => {
    return state.auth.redirectUrl;
  });

  useEffect(() => {
    (async () => {
      try {
        if (router.query.code !== undefined) {
          const data = await googleLogin({ code: router.query.code });
          await fetch("/api/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ accessToken: data }),
          });
          dispatch(setTokens(data));
          const user: any = await getUser();
          dispatch(setUser(user));
          dispatch(setBidderUser(user));
          const validateBidderEmail = await checkAndUpdateBidder(
            user?.attributes[0]?.value,
            user.uuid,
          );
          const subscription = await getSubscriptionByUserUuid(user.uuid);
          if (subscription) {
            dispatch(setSubscription(subscription));
          }
          const onboardingData: any = await getBidderOnboardingOfUser(
            user.uuid,
          );
          if (onboardingData) {
            dispatch(setOnboarding(onboardingData));
            dispatch(setBidderOnboarding(onboardingData));
          } else {
            const payload: any = {
              user_uuid: user.uuid,
            };
            if (user?.profile?.name) {
              payload["name"] = user.profile?.name;
              // payload["authorized_person_name"] = user.profile?.name;
            }
            const res: any = await createBidderOnboardingWithOutData(payload);
            dispatch(setOnboarding(res));
            dispatch(setBidderOnboarding(res));
          }
          if (user?.attributes.length !== 2) {
            if (redirectUrl) {
              router.push(redirectUrl);
            } else {
              router.push("/dashboard/profile");
            }
          } else {
            if (redirectUrl) {
              router.push(redirectUrl);
            } else {
              router.push("/");
            }
          }
        }
      } catch (error) {
        console.log("check here error", error);
        router.push("/");
      }
    })();
  }, [router.query]);

  return (
    <div className="px-4 sm:px-6 lg:px-20 xl:px-24 min-h-screen">
      <div className="flex justify-center items-center w-full min-h-screen">
        <Loader height="h-16" width="w-16" color="text-brand-orange" />
      </div>
    </div>
  );
}
